import { createSelector, MemoizedSelector } from '@ngrx/store';
import { getFenceResultState } from '@app/store/faxe/faxe-selectors';
import { selectAllFenceResult } from '@app/store/faxe/fence-result/fence-result.reducer';
import { FenceResult } from '@app/rest-client/faxe/models/fence-result';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { defined } from '@app/fremework/functions';

export const selectFenceResultAll: MemoizedSelector<object, FenceResult[]> = createSelector(
  getFenceResultState,
  selectAllFenceResult);

export const selectFenceResultsState =
  ():
    MemoizedSelector<object, { fenceResults: FenceResult[], sliceState: SliceState }> =>
    createSelector(
      getFenceResultState,
      selectFenceResultAll,
      (state, all) => ({
        fenceResults: all,
        sliceState: state?.meta?.sliceState
      })
    );

export const selectFenceResultByRaceGuid =
  (raceGuid: string, sliceState: SliceState):
    MemoizedSelector<object, FenceResult[]> =>
    createSelector(
      getFenceResultState,
      selectFenceResultAll,
      (state, all) =>
        all
          .filter(fenceResult => (defined(state?.meta?.sliceState) &&
              (state.meta.sliceState === SliceState.total || sliceState === SliceState.reportable))
            && fenceResult.raceGuid === raceGuid)
    );
